import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

export default class Jobb extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      cv:'',
      brev:'',
      bild:'',
      namn:'',
      personnr:'',
      adress:'',
      mobilnr:'',
      nationalitet:'',
      alder:'',
      sending:false,
      sent:false,
    };
  }

  handleInputChange(ev) {
    const value = ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value;

    this.setState({
      [ev.target.name]: value,
    });
  }

  render(){
    return(
      <Layout>
        <SEO title="Jobba hos oss" keywords={[`gatsby`, `application`, `react`]} />
        <div className="page">
          <div className="page-header">
            <h1>Jobba hos oss</h1>
          </div>
          <div className="container tight text-outer">
            <p>Thai House Wok är mitt i en spännande tillväxtfas och vi söker ständigt duktiga och serviceinriktade medarbetare. Hos oss finner du ett spännande och utvecklande arbete i ett framgångsrikt och uppskattat företag.</p>
            <div className="row justify-content-center">
              <div className="col-8 col-md-6 mb-4">
                <Link to="/jobbansokan" className="btn btn-block btn-lg pl-0 pr-0 btn-orange">Till Jobbansökan &raquo;</Link>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}
